// Frontend Configuration
// This file contains configurable settings for the Medical Tracker frontend

const config = {
  // API Configuration
  api: {
    // Base URL for API calls
    // In development: 'http://localhost:8000'
    // In production (with nginx): '' (empty string uses relative URLs)
    baseUrl: process.env.REACT_APP_API_BASE_URL || '',
    
    // Alternative configurations for different environments
    // Uncomment the appropriate line for your setup:
    
    // For local development with separate backend:
    // baseUrl: 'http://localhost:8000',
    
    // For Docker with nginx proxy (default):
    // baseUrl: '',
    
    // For production with custom domain:
    // baseUrl: 'https://your-domain.com',
    
    // For production with API subdomain:
    // baseUrl: 'https://api.your-domain.com',
  },
  
  // Application Configuration
  app: {
    name: 'Medical Tracker',
    version: '1.0.0',
    itemsPerPage: 10,
  },
  
  // UI Configuration
  ui: {
    theme: {
      primary: 'medical',
      colors: {
        medical: {
          50: '#f0f9ff',
          100: '#e0f2fe',
          200: '#bae6fd',
          300: '#7dd3fc',
          400: '#38bdf8',
          500: '#0ea5e9',
          600: '#0284c7',
          700: '#0369a1',
          800: '#075985',
          900: '#0c4a6e',
        }
      }
    }
  }
};

// Helper function to get full API URL
export const getApiUrl = (endpoint = '') => {
  const baseUrl = config.api.baseUrl;
  if (!baseUrl) {
    // Use relative URLs when baseUrl is empty
    return endpoint;
  }
  // Ensure no double slashes
  const cleanBaseUrl = baseUrl.replace(/\/$/, '');
  const cleanEndpoint = endpoint.replace(/^\//, '');
  return `${cleanBaseUrl}/${cleanEndpoint}`;
};

// Helper function to get API base URL
export const getApiBaseUrl = () => {
  return config.api.baseUrl;
};

export default config;
